import { color } from '@creditornot/cb-ingredients/design-tokens';
import React from 'react';
import styled from 'styled-components';

import { Template } from 'apis/asset-repository-service/types';
import { Typography as T } from 'common/typography';

type Props = {
  template: Template;
  selected?: boolean;
  disabled?: boolean;
  onClick: (id: string) => void;
};

const Root = styled.div<{ $selected?: boolean; $disabled?: boolean }>`
  padding: ${props => (props.$selected ? '7px' : '8px')};
  border: ${props => (props.$selected ? '2px' : '1px')} solid
    ${props => (props.$selected ? color.borderSelected : color.border)};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  opacity: ${({ $selected, $disabled }) => (!$selected && $disabled ? 0.5 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  transition: opacity 400ms;
`;

const TemplateBackground = styled.div<{ $background: string }>`
  height: 90px;
  background: ${props => props.$background};
  background-size: cover;
  border-radius: 8px;
`;

const TemplateName = styled(T.Small)`
  font-weight: 500;
`;

export const TemplateCard = ({ template, selected, disabled, onClick }: Props) => {
  const { background, name } = template;
  const cssBackground = background.startsWith('http') ? `url(${background})` : '#' + background;

  return (
    <Root
      $selected={selected}
      $disabled={disabled}
      onClick={() => {
        if (!disabled) {
          onClick(template.id);
        }
      }}
    >
      <TemplateBackground $background={cssBackground} />
      <TemplateName>{name}</TemplateName>
    </Root>
  );
};
